import React from "react";
import { useAuth } from "../../lib/AuthContext";
import { getFileIcon, handleGetFiles } from "../../common/Constants";
import { useGetFileMutation } from "../hooks/useGetFileMutation";

const DocumentList: React.FC<any> = ({ data }) => {
  const getFilesApi = useGetFileMutation();

  const { userDetails } = useAuth();

  const userId = userDetails?.userId ?? "";
  const userName = userDetails?.username ?? "";
  const userEmail = userDetails?.email ?? "";

  const userNameEmail = `${userName}_${userEmail}`;

  if (!data || typeof data !== "object") {
    return <p className="text-red-500">Error: Invalid file data format</p>;
  }

  return (
    <div className="bg-white rounded-lg my-2 mb-4">
      <div className="space-y-1">
        {Object.entries(data).map(([fileName, details]: any) => {
          return (
            <div key={fileName} className="p-0 rounded-md flex flex-col gap-0">
              <div className="font-medium text-primary_1 dark:text-dark-primary_1 m-0 flex gap-2 items-center justify-between mb-[2px]">
                <div className="flex gap-2 items-center">
                  <img
                    src={getFileIcon(fileName)}
                    alt="file icon"
                    className="h-6"
                  />
                  <button
                    // onClick={() => handleGetFiles(fileName, details.database)}
                    onClick={() =>
                      handleGetFiles(
                        fileName,
                        details.database,
                        getFilesApi,
                        userId,
                        userNameEmail,
                        false
                      )
                    }
                    className="text-sm leading-[170%] font-medium text-[#0F62FE] line-clamp-1 text-left break-all"
                  >
                    {fileName}
                  </button>
                  <span className="text-xs flex gap-1 items-center capitalize bg-prompt_bg px-2 py-1 rounded-[4px]">
                    {details.database || "Unknown"}
                  </span>
                </div>
              </div>
              <div className="text-[#1F1F1F] text-xs leading-[140%] px-8 line-clamp-2">
                {details.description || "No description available"}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DocumentList;
